<template>
  <div>
    <pulse-loader v-if="loading" />
    <template v-else>
      <common-sso />
    </template>
  </div>
</template>

<script>
import CommonSso from './CommonSso';
import { CommonSecurity } from '@primeit/components-vue';
import PulseLoader from '../../../components/PulseLoader';

export default {
  components: {
    CommonSso,
    PulseLoader,
  },
  data: () => {
    return {
      loading: true,
    };
  },
  computed: {
    setup() {
      return this.$store.getters['credential/SETUP'];
    },
    getUser() {
      return CommonSecurity.getUser();
    },
  },
  beforeMount() {
    if (document.location.pathname.startsWith('/emergency')) {
      window?.Tawk_API?.minimize();
      window?.Tawk_API?.hideWidget();
    }
  },
  mounted() {
    const vm = this;
    window.addEventListener('message', (event) => {
      const data = event.data;

      if (data?.event && data.event === 'go_home') {
        vm.$router.push('/');
      }
    });
  },
  async created() {
    const user = await this.getUser;

    if (!user && this.setup?.landing?.enabled) {
      const landingKnownPaths = ['/', '/professionals'];
      let params = {};

      if (!landingKnownPaths.includes(this.$route.path)) {
        params = {
          permalink: this.$route.path.replace('/', ''),
        };
      }

      return this.$router.replace({ name: 'landing', query: this.$route.query, replace: true, params });
    }

    this.loading = false;
  },
  methods: {},
};
</script>
